export default __webpack_public_path__ + "media/images/logos/monitoring_logo_blue-4abb5e7a47996d144205ff5d0d96b5e8.svg";